import store from '../store'
export default {
  parseMessage (channelId, msg) {
    // if (channelId === 'doctors_channel') {
    let message = JSON.parse(msg.data)
    if (message.intent_name === 'join_channel') {
      store.dispatch('consultationRequest/addConsultationRequest', message) // save message in queue for display
    } else if (message.intent_name === 'reject') {
      console.log('One of the doctors has rejected this request')
    } else if (message.intent_name === 'already_assigned' && message.doctor_id !== store.state.configuration.doctorId) {
      store.dispatch('consultationRequest/removeRequest', {message: message, status: 'already_assigned'})
    } else if (message.intent_name === 'request_cancelled') {
      store.dispatch('consultationRequest/removeRequest', {message: message, status: 'cancelled'})
    } else if (message.intent_name === 'request_missed') {
      store.dispatch('consultationRequest/missedConsultationRequest', message)
    } else if (message.intent_name === 'request_queried') {
      store.dispatch('consultationRequest/queriedConsultationRequest', message)
    } else if (message.intent_name === 'notification') {
      store.dispatch('notification/addNotification', {notification: message.payload})
    } else {
      store.dispatch('message/receive', { channelId, message })
    }
  },

  buildWelcomeTextMessage (data) {
    let timeInMilliSeconds = new Date().getTime()
    let name = store.state.configuration.name
    let text = 'Hi, This is ' + name + '. I am here to help you with your health query.'
    if (data.patient.isFamilyDoctor) text = `Hi ${data.patient.name}, good to connect with you today.`
    return {
      intentName: 'incoming_text',
      uniqueId: timeInMilliSeconds,
      payload: {text: text},
      user: { 'type': 'doctor' },
      timestamp: timeInMilliSeconds,
      transient: false,
      consultation_request_id: data.patient.consultationRequest.consultationRequestId,
      customer_id: data.activeCustomerId
    }
  },

  buildMessage (payload, options) {
    if (options.patient) {
      let timeInMilliSeconds = new Date().getTime()
      return {
        intentName: options.intentName,
        uniqueId: timeInMilliSeconds,
        payload: payload,
        timestamp: timeInMilliSeconds,
        user: { 'type': 'doctor' },
        transient: false,
        consultation_request_id: options.patient.consultationRequest.consultationRequestId,
        // since cuatomer side we are not sending consultation id so not send it from here either
        // consultation_id: patient.consultation.consultationId, // need to figure it out
        customer_id: options.activeCustomerId
      }
    }
  },

  buildFileData (fileList, options) {
    if (options.patient) {
      var formData = new FormData()
      formData.append('customer_id', options.activeCustomerId)
      formData.append('consultation_id', options.consultationId)
      formData.append('files[]', fileList[0], fileList[0].name)
      return formData
    }
  },

  buildTempFileData (file) {
    file.progress = 0
    file.state = 'preparing'                                  // has 4 states : preparing, uploading, uploaded, reload
    file.intentName = 'file_attachment'
    file.payload = {file_url: '', file_name: file.name}
    file.user = { type: 'doctor' }
    return file
  },

  buildDocumentMessage (data) {
    if (data.patient) {
      // create send data based on conditions like documents or presciption etc
      let sendData = {
        url: data.url,
        type: data.type,
        fileIntent: data.intentName,
        fileName: data.fileName,
        channelId: data.activeChannelId,
        customer_id: data.activeCustomerId,
        consultation_request_id: data.activeConsultationRequestId
      }
      let timeInMilliSeconds = new Date().getTime()
      var msg = {
        uniqueId: timeInMilliSeconds,
        intentName: data.intentName,
        payload: { id: data.id, file_url: sendData.url, file_name: sendData.fileName, unique: sendData.channelId + timeInMilliSeconds },
        user: { type: 'doctor' },
        transient: false,
        consultation_id: data.activeConsultationId,
        consultation_request_id: sendData.consultation_request_id,
        customer_id: sendData.customer_id
      }
      if (sendData.type === 'prescription') {
        msg.payload.medications = data.medications
        // msg.payload.prescription_id = data.prescriptionId
        // msg.payload.labtests = (sendData.labtests !== undefined) ? sendData.labtests : null
      }
      return msg
    }
  },

  buildPresenceUpdate (data) {
    if (data.isTyping !== undefined) {
      if (data.isTyping === true) {
        data.typing = true
      } else {
        data.typing = false
      }
      delete data.isTyping
    } else if (data.isDelivered !== undefined && data.isDelivered === true) {
      delete data.isDelivered
      data.typing = false
    } else if (data.isRead !== undefined && data.isRead === true) {
      delete data.isRead
      data.typing = false
    }
    data.transient = false
    data.user = { 'type': 'doctor' }
    return data
  }
}



// WEBPACK FOOTER //
// ./src/core/parser.js